import { render } from "./TheLichThuGomRac.vue?vue&type=template&id=6275de24"
import script from "./TheLichThuGomRac.vue?vue&type=script&lang=js"
export * from "./TheLichThuGomRac.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__